export default {
  'Regular homework': {
    hasGroupName: true,
    hasGroupLevel: true,
  }
}